<template lang="pug">

table.ui.fixed.padded.table
    thead
        tr
            th.two.wide Benutzername
            th.four.wide Unternehmen
            th.two.wide Vorname
            th.two.wide Nachname
            th.four.wide E-Mail
            th.one.wide Status
    tbody
        tr(
            is='row'
            v-bind:company-models='companyModels'
            v-bind:person-models='personModels'
            v-bind:user-model='userModel'
            v-for='userModel in userModels'
            v-bind:key='userModel.id'
        )

</template>

<script>
    import Row from './table/Row.vue'

    // noinspection JSUnusedGlobalSymbols
    export default {

        components: { Row },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            },

            userModels: {
                type: Array,
                required: true
            }

        }
    }

</script>
